import {
  AccordionItem,
  AccordionHeader,
  AccordionBody,
} from "./FAQ.styles";

import { FiPlus, FiMinus } from "react-icons/fi";
import { useId } from "react";

const FAQItem = ({ question, answer, open, onToggle }) => {
  const answerId = useId();
  return (
    <AccordionItem>
      <AccordionHeader type="button" onClick={onToggle} aria-expanded={open} aria-controls={answerId}>
        <span>{question}</span>

        <span className="shrink-0 ml-6 flex items-center justify-center">
          {open ? <FiMinus size={36} /> : <FiPlus size={36} />}
        </span>
      </AccordionHeader>

      <AccordionBody id={answerId} $open={open}>{answer}</AccordionBody>
    </AccordionItem>
  );
};

export default FAQItem;
